import React from "react";
import styles from "./DashboardHome.module.scss";
import PromoBanner from "../../../components/PromoBanner/PromoBanner";
import StatsOverview from "../../../components/StatsOverview/StatsOverview";
import RequestCart from "../../../components/Charts/RequestCart";
import PricingCards from "../../../components/PricingCards/PricingCards";
import { useTranslation } from "react-i18next";

const DashboardHome = () => {
  const { i18n } = useTranslation();

  return (
    <div className={styles.accountPage}>
      <h1 className={styles.title}>{i18n.t("home")}</h1>
      <header className={styles.accountHeader}>
        <PromoBanner i18n={i18n} />
      </header>
      <StatsOverview />
      <RequestCart />
      <PricingCards />
    </div>
  );
};

export default DashboardHome;
